<div class="page-head-section">
  <p>Hall of Fame</p>
</div>

<div class="award-content">
  <p-tabView>
    <p-tabPanel header="Arjuna Award">
      <div>
        <div class="ui-g">
          <div *ngFor="let data of ArjunAwards" class="ui-g-3 ui-lg-3 ui-md-6 ui-sm-12">
            <div class="award-card">
              <div class="award-card-image">
                <img class="image-responsive" [src]="data.photo" alt="" />
              </div>
              <div class="award-card-content">
                <h1>{{ data?.name }}</h1>
                <p>{{ data?.year }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Dronacharya Awards">
      <div>
        <div class="ui-g">
          <div *ngFor="let data of DronaAwards" class="ui-g-3 ui-lg-3 ui-md-6 ui-sm-12">
            <div class="award-card">
              <div class="award-card-image">
                <img class="image-responsive" [src]="data.photo" alt="" />
              </div>
              <div class="award-card-content">
                <h1>{{ data?.name }}</h1>
                <p>{{ data?.year }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Dhyan chand Award">
      <div>
        <div class="ui-g">
          <div *ngFor="let data of DhyanChand" class="ui-g-3 ui-lg-3 ui-md-6 ui-sm-12">
            <div class="award-card">
              <div class="award-card-image">
                <img class="image-responsive" [src]="data.photo" alt="" />
              </div>
              <div class="award-card-content">
                <h1>{{ data?.name }}</h1>
                <p>{{ data?.year }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Padmashree Award">
      <div>
        <div class="ui-g">
          <div *ngFor="let data of PadmaShree" class="ui-g-3 ui-lg-3 ui-md-6 ui-sm-12">
            <div class="award-card">
              <div class="award-card-image">
                <img class="image-responsive" [src]="data.photo" alt="" />
              </div>
              <div class="award-card-content">
                <h1>{{ data?.name }}</h1>
                <p>{{ data?.year }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
